<template>
    <Paper class="penalty-charge finance-detail">
        <div class="contents" v-loading="fineLoading">
            <div class="buttons">
                <el-button @click="goLists">返 回</el-button>
            </div>
            <div class="base-line"></div>
            <div class="head-content">
                <div class="head-title">
                    <div class="head-t">
                        <h3 class="head-h3">罚扣款单号：{{this.$route.query.supFineNo}}</h3>
                    </div>
                    <el-button class="head-btn" @click="isShow = !isShow">{{this.isShow ? '收起' : '展开'}}</el-button>
                </div>
                <el-collapse-transition>
                    <div v-show="isShow" class="head">
                        <ElRow :infoData="infoData"></ElRow>
                    </div>
                </el-collapse-transition>
            </div>
            <div class="details-title">
                <div class="left">
                    <span class="bill-details">明细</span>
                </div>
            </div>
            <template class="table-head">
                <el-table v-loading="loading" :data="tableDataLists" border height="500" ref="dragTable" style="width: 100%">
                    <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width" v-for="(item, index) in tableDataItems" :key="index"></el-table-column>
                </el-table>
            </template>
        </div>
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import index from './config.js';
import { getFineDetails, getFineTasks } from '../../../api/cost.js';
import ElRow from './components/ElRow';
import { mapGetters } from 'vuex';
import common from '../../../common/common';
import LoadAndUnloadClass from '../../../common/FineDetailsClass';
const { initSessionData } = common;
export default {
    name: 'fineDetailsIndex',
    components: { Paper, ElRow },
    computed: {
        ...mapGetters(['visitedViews'])
    },
    data() {
        return {
            infoData: {},
            isShow: true,
            index: index,
            tableDataLists: [],
            tableDataItems: [],
            loading: false,
            fineLoading: false
        };
    },
    methods: {
        routeJump() {
            this.$message.closeAll();
            this.$message.warning('没有对应的单据编号，不允许查询数据详情');
            this.$router.push({ path: `/bms/fine` });
            this.visitedViews.forEach(e => {
                if (e.fullPath === this.$route.fullPath) {
                    this.$store.dispatch('delView', e);
                }
            });
        },
        getData() {
            if (this.$route.query.hasOwnProperty('supFineNo') && this.$route.query.supFineNo !== null) {
                this.fineLoading = true;
                const params = { pageNo: 1, pageSize: 10, supFineNo: this.$route.query.supFineNo };
                getFineTasks(params).then(res => {
                    if (res && res.code === '0') {
                        const fineObj = res.data.list[0];
                        const { BID_BUSINESS_TYPE, SRM_YES_NO } = window.sessionStorage;
                        fineObj.operationType = BID_BUSINESS_TYPE ? JSON.parse(BID_BUSINESS_TYPE)[fineObj.operationType] : fineObj.operationType;
                        this.infoData = new LoadAndUnloadClass(fineObj);
                        this.infoData.isReplaceSettlement = SRM_YES_NO ? JSON.parse(SRM_YES_NO)[fineObj.isReplaceSettlement] : fineObj.isReplaceSettlement;
                        this.infoData.isAccident = SRM_YES_NO ? JSON.parse(SRM_YES_NO)[fineObj.isAccident] : fineObj.isAccident;
                    }
                    this.fineLoading = false;
                    this.load();
                }).catch(() => {});
            } else {
                this.fineObj = {};
                this.routeJump();
            }
        },
        load() {
            if (this.$route.query.hasOwnProperty('supFineNo') && this.$route.query.supFineNo !== null) {
                var temp = { supFineNo: this.$route.query.supFineNo };
                this.loading = true;
                getFineDetails(temp).then(res => {
                    this.loading = false;
                    this.tableDataLists = res.data.list;
                });
            } else {
                this.tableDataLists = [];
                this.loading = false;
                this.routeJump();
            }
        },
        goLists() {
            this.$router.push({
                path: `/bms/fine`
            });
        }
    },
    mounted() {
        initSessionData(['BID_BUSINESS_TYPE', 'SRM_YES_NO']);
        this.getData();
    },
    activated() {
        this.getData();
    },
    created() {
        this.infoData = index.infoData;
        this.tableDataItems = index.tableDataItems;
        this.costTableDataItems = index.costTableDataItems;
    }
};
</script>

<style lang="less">
@import "../../../styles/common.less";
@import "./fineDetails.less";
</style>